import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Avatar, Badge, Menu, MenuItem, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MailIcon from '@mui/icons-material/Mail';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

// Import the page titles mapping
const PAGE_TITLES = {
  '/': 'Dashboard',
  '/products': 'Products',
  '/variants': 'Variants',
  '/inventory/location': 'Inventory Location',
  '/sale-return': 'Sale & Return',
  '/inventory/pick-list': 'Pick List',
  '/marketplace/amazon': 'Amazon Marketplace',
  '/marketplace/flipkart': 'Flipkart Marketplace',
  '/marketplace/myntra': 'Myntra Marketplace',
  '/marketplace/ajio': 'Ajio Marketplace',
  '/marketplace/nykaa': 'Nykaa Marketplace',
  '/utility': 'Utility',
  '/settings': 'Settings',
  '/logout': 'Logout'
};

const Header = ({ children }) => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  
  // Get the current page title based on the route
  const pageTitle = PAGE_TITLES[location.pathname] || 'Inventory Management System';
  
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleLogout = () => {
    logout();
    handleClose();
    navigate('/login');
  };
  return (
    <AppBar position="sticky" color="default" elevation={0} sx={{ backgroundColor: 'white', borderBottom: '1px solid #eee' }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {children}
          <Typography variant="h6" component="div" sx={{ color: '#333', fontWeight: 500, display:{ md: 'block', xs: 'none'} }}>
            {pageTitle}
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton size="medium" color="inherit" sx={{ mr: 1 }}>
            <Badge badgeContent={4} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton>
          
          <IconButton size="medium" color="inherit" sx={{ mr: 2 }}>
            <Badge badgeContent={2} color="primary">
              <MailIcon />
            </Badge>
          </IconButton>
          
          
          
          {currentUser ? (
            <>
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'flex-end',
                mr: 1
              }}>
                <Typography variant="body2" sx={{ color: '#333' ,display:{ md: 'block', xs: 'none'} }}>
                  {currentUser.email}
                </Typography>
                <Typography variant="body2" sx={{ color: '#666', fontSize: '0.8rem',display:{ md: 'block', xs: 'none'} }}>
                  {currentUser.first_name} {currentUser.last_name}
                </Typography>
              </Box>
              <Tooltip title="Account settings">
                <IconButton onClick={handleMenu} size="small">
                  <Avatar sx={{ bgcolor: '#3f51b5', width: 32, height: 32 }}>
                    {currentUser.first_name ? currentUser.first_name[0] : currentUser.email[0].toUpperCase()}
                  </Avatar>
                </IconButton>
              </Tooltip>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleLogout}>
                  <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                  Logout
                </MenuItem>
              </Menu>
            </>
          ) : null}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
